import { Icon } from '@openeducation/oe-rn-components';
import color from 'color';
import React from 'react';
import {
  Platform,
  StyleSheet,
  TouchableOpacity,
  TouchableOpacityProps,
  View,
} from 'react-native';

import { useColors } from '../../../hooks';
import { useSoundContext } from '../../../hooks/use-sound-context';

interface SlowButtonProps extends TouchableOpacityProps {
  activeColor?: string;
  inactiveColor?: string;
}

export function SlowButton({
  activeColor = undefined,
  inactiveColor = undefined,
  disabled,
  ...props
}: SlowButtonProps) {
  const { isSlow, toggleSlow, status } = useSoundContext();
  const theme = useColors();
  let buttonColor = inactiveColor || theme.onBackground;

  if (isSlow) {
    buttonColor = activeColor || theme.primary;
  }

  return (
    <View style={styles.container}>
      <TouchableOpacity
        onPress={toggleSlow}
        disabled={!status.isLoaded || disabled}
        {...props}
      >
        <Icon
          color={color(buttonColor)
            .alpha(isSlow ? 1 : 0.7)
            .string()}
          size={22}
          name="turtle"
          type="solid"
        />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: Platform.select({
      web: 0,
      ios: 9,
      android: -3,
    }),
  },
});
